module.exports = __webpack_public_path__ + "img/pn.83ce9fee.png";